const AppStateService = {
  user: null,
  customer: null,

  /**
   * Reset app state
   */
  reset() {
    this.removeUser();
  },

  /**
   * Set user
   */
  setUser(user) {
    this.user = user;
  },

  /**
   * Remove current user
   */
  removeUser() {
    this.user = null;
    this.customer = null;
  },

  /**
   * Check if a user is present
   */
  hasUser() {
    return this.user !== null;
  },

  /**
   * Set customer
   */
  setCustomer(customer) {
    this.customer = customer;
  }
};

export default AppStateService;
